import { render } from "./App.vue?vue&type=template&id=24b13c45"
const script = {}
script.render = render

export default script